"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainId = exports.getDefaultChainId = exports.getSupportedChainIds = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const env_1 = __importDefault(require("../../utils/env"));
const CHAIN_ID = ((0, env_1.default)('CHAIN_ID') || (0, env_1.default)('DEFAULT_CHAIN_ID', String(chain_id_1.ChainId.ETHEREUM_MAINNET)))
    .split(',')
    .filter(Boolean)
    .map((chainId) => Number(chainId));
function getSupportedChainIds() {
    return CHAIN_ID;
}
exports.getSupportedChainIds = getSupportedChainIds;
function getDefaultChainId() {
    return CHAIN_ID[0];
}
exports.getDefaultChainId = getDefaultChainId;
function getChainId() {
    return CHAIN_ID[0];
}
exports.getChainId = getChainId;
